import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form/immutable';
import Input from '../common/Input';

const BasicForm = ({ children, submitting }) => (
  <div>
    <div>
      <Field
        name="email"
        label="Email"
        type="email"
        component={Input}
      />
    </div>
    <div>
      <Field
        name="firstName"
        label="Nombre"
        type="text"
        component={Input}
      />
    </div>
    <div>
      <Field
        name="lastName"
        label="Apellido"
        type="text"
        component={Input}
      />
    </div>
    <div>
      <Field
        name="ci"
        label="Cédula de Identidad (sin puntos ni guiones)"
        component={Input}
        type="text"
      />
    </div>
    <div>
      <Field
        name="phone"
        label="Teléfono"
        type="text"
        component={Input}
      />
    </div>
    <div>
      <Field
        name="address"
        label="Dirección"
        type="text"
        component={Input}
      />
    </div>
    { children }
    <div>
      <Field
        name="password"
        label="Contraseña"
        type="password"
        component={Input}
      />
    </div>
    <div>
      <Field
        name="passwordConfirmation"
        label="Confirmar contraseña"
        type="password"
        component={Input}
      />
    </div>
    <button
      className={`default-button ${submitting ? 'loading-button' : ''}`}
      type="submit"
    >
      Crear Cuenta
    </button>
  </div>
);

const { array, bool } = PropTypes;

BasicForm.propTypes = {
  children: array,
  submitting: bool
};

export default BasicForm;



// WEBPACK FOOTER //
// ./src/components/user/BasicForm.js